// extracted by mini-css-extract-plugin
module.exports = {"root":"onlineBadge_root__kTgd9","live":"onlineBadge_live__uoFCT"};